module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "repeater-wrap"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "input-wrap input-wrap--address"
  }, [_c('button', {
    staticClass: "input input--address address__button",
    on: {
      "click": _vm.openPanel
    }
  }, [_c('address', {
    domProps: {
      "innerHTML": _vm._s(_vm.setFullAddress)
    }
  })]), _vm._v(" "), _c('Icon', {
    attrs: {
      "icon": "house"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e1b1530!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Address.vue
// module id = 326
// module chunks = 0